import type { ReactElement } from "react";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Flex, Text } from "@similarweb/ui-components/foundations";

import { useTranslation } from "pro-features/components/WithTranslation";

import { StyledContactUsSuccessImageWrapper, StyledContactUsSuccessState } from "./styles";

interface IProps {
    className?: string;
}

const ContactUsSuccessState = ({ className }: IProps): ReactElement => {
    const translate = useTranslation();

    return (
        <StyledContactUsSuccessState
            className={className}
            alignItems="center"
            justifyContent="center"
            gap="16px"
            data-automation="upsell-success-overlay"
        >
            <StyledContactUsSuccessImageWrapper>
                <SWReactIcons
                    iconName="reaching-out-state"
                    size="140px"
                />
            </StyledContactUsSuccessImageWrapper>
            <Flex
                flexDirection="column"
                gap="4px"
            >
                <Text
                    fontVariant="body2"
                    color={colorsPalettes.carbon[500]}
                    data-automation="upsell-success-overlay.title-text"
                >
                    {translate("si.advanced_search.results_section.contacts.pending-heading")}
                </Text>
                <Text
                    fontVariant="caption"
                    color={colorsPalettes.carbon[400]}
                    data-automation="upsell-success-overlay.subtitle-text"
                >
                    {translate("si.advanced_search.results_section.contacts.pending-paragraph")}
                </Text>
            </Flex>
        </StyledContactUsSuccessState>
    );
};

export default ContactUsSuccessState;
